module.exports = __webpack_public_path__ + "ae132aaa234a7c4ba2809ff30b0140df.svg";